module.exports = __webpack_public_path__ + "img/triangle-wave.8cedbdce.svg";